import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import Product from '../models/Product.model';
import { AppSettingsService } from './app-settings.service';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private settingsService = inject(AppSettingsService);

  public product: WritableSignal<Product | null> = signal(null);
  public isOpen = signal(false);

  open(product: Product) {
    if (!this.settingsService.isOrderingEnabled()) {
      return;
    }
    this.product.set(product);
    this.isOpen.set(true);
  }

  close() {
    this.isOpen.set(false);
    setTimeout(() => {
      this.product.set(null);
    }, 300);
  }
}
